import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { vehicleTypes } from '../mock/destinations';
import { formatPrice, calculateTotalPrice } from '../utils/formatters';

const VehicleSelector = ({ basePrice = 45000, passengers = 1, onSelect = () => {} }) => {
  const [selectedVehicle, setSelectedVehicle] = useState('sedan');

  const handleSelect = (vehicleId) => {
    setSelectedVehicle(vehicleId);
    const vehicle = vehicleTypes.find(v => v.id === vehicleId);
    onSelect(vehicle);
  };

  return (
    <motion.div 
      className="bg-white/90 backdrop-blur-xl border border-gray-200/50 rounded-3xl p-8 shadow-xl"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h3 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Selecciona tu vehículo
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {vehicleTypes.map((vehicle, index) => {
          const totalPrice = calculateTotalPrice(basePrice, vehicle.price, passengers);
          const isSelected = selectedVehicle === vehicle.id;
          
          return (
            <motion.div
              key={vehicle.id}
              className={`relative p-6 rounded-2xl border-2 cursor-pointer transition-all duration-300 ${
                isSelected 
                  ? 'border-green-500 bg-green-50' 
                  : 'border-gray-200 bg-white hover:border-green-300 hover:bg-green-25'
              }`}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => handleSelect(vehicle.id)}
            >
              {isSelected && (
                <motion.div 
                  className="absolute top-4 right-4 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ type: "spring", duration: 0.3 }}
                >
                  <Check className="w-4 h-4 text-white" />
                </motion.div>
              )}

              <div className="text-center">
                <div className="text-4xl mb-3">{vehicle.icon}</div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">{vehicle.name}</h4>
                <p className="text-sm text-gray-600 mb-2">{vehicle.capacity}</p>
                <p className="text-xs text-gray-500 mb-4">{vehicle.description}</p>
                
                <div className="text-center">
                  <span className="text-xl font-bold text-green-600">
                    {formatPrice(totalPrice)}
                  </span>
                  <p className="text-xs text-gray-500">precio total</p>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};

export default VehicleSelector;